/* tslint:disable */
/* eslint-disable */
/**
 * Walnut Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 4.155.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * @export
 */
export const SettingsSchemaGeneralAxeCoreVersionValueEnum = {
    Latest: 'latest',
    _4103: '4.10.3',
    _4102: '4.10.2',
    _4101: '4.10.1',
    _4100: '4.10.0',
    _410: '4.10',
    _491: '4.9.1',
    _490: '4.9.0',
    _49: '4.9',
    _484: '4.8.4',
    _483: '4.8.3',
    _482: '4.8.2',
    _481: '4.8.1',
    _480: '4.8.0',
    _48: '4.8',
    _472: '4.7.2',
    _471: '4.7.1',
    _470: '4.7.0',
    _47: '4.7',
    _463: '4.6.3',
    _462: '4.6.2',
    _461: '4.6.1',
    _460: '4.6.0',
    _46: '4.6',
    _452: '4.5.2',
    _451: '4.5.1',
    _450: '4.5.0',
    _45: '4.5',
    _443: '4.4.3',
    _442: '4.4.2',
    _441: '4.4.1',
    _440: '4.4.0',
    _44: '4.4'
};
/**
 * @export
 */
export const SettingsSchemaGeneralAxeCoreVersionTypeEnum = {
    Fixed: 'fixed',
    Default: 'default',
    OneOf: 'oneOf'
};
/**
 * @export
 */
export const SettingsSchemaGeneralAxeCoreVersionOptionsEnum = {
    Latest: 'latest',
    _4103: '4.10.3',
    _4102: '4.10.2',
    _4101: '4.10.1',
    _4100: '4.10.0',
    _410: '4.10',
    _491: '4.9.1',
    _490: '4.9.0',
    _49: '4.9',
    _484: '4.8.4',
    _483: '4.8.3',
    _482: '4.8.2',
    _481: '4.8.1',
    _480: '4.8.0',
    _48: '4.8',
    _472: '4.7.2',
    _471: '4.7.1',
    _470: '4.7.0',
    _47: '4.7',
    _463: '4.6.3',
    _462: '4.6.2',
    _461: '4.6.1',
    _460: '4.6.0',
    _46: '4.6',
    _452: '4.5.2',
    _451: '4.5.1',
    _450: '4.5.0',
    _45: '4.5',
    _443: '4.4.3',
    _442: '4.4.2',
    _441: '4.4.1',
    _440: '4.4.0',
    _44: '4.4'
};
/**
 * Check if a given object implements the SettingsSchemaGeneralAxeCoreVersion interface.
 */
export function instanceOfSettingsSchemaGeneralAxeCoreVersion(value) {
    let isInstance = true;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
export function SettingsSchemaGeneralAxeCoreVersionFromJSON(json) {
    return SettingsSchemaGeneralAxeCoreVersionFromJSONTyped(json, false);
}
export function SettingsSchemaGeneralAxeCoreVersionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'value': json['value'],
        'type': json['type'],
        'options': !exists(json, 'options') ? undefined : json['options'],
    };
}
export function SettingsSchemaGeneralAxeCoreVersionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'value': value.value,
        'type': value.type,
        'options': value.options,
    };
}
